export const data = [
    {
        id: 1,
        name: 'Medium',
        type: 'News / Information',
        description: 'Medium is a new place on the Internet where people share ideas and stories that are longer than 140 characters and not just for friends. It’s designed for little stories that make your day better and manifestos that change the world. It’s used by everyone from professional journalists to amateur cooks. It’s simple, beautiful, collaborative, and it helps you find the right audience for whatever you have to say.',
        site_logo: "https://miro.medium.com/max/3150/1*6_fgYnisCa9V21mymySIvA.png",
        link: "https://medium.com/"
    },
    {
        id: 2,
        name: 'Udemy',
        type: 'Education',
        site_logo: "https://pbs.twimg.com/profile_images/1145698421107392513/1ocHxLkr_400x400.png",
        description: "Udemy helps organizations of all kinds prepare for the ever-evolving future of work. Our curated collection of top-rated business and technical courses gives companies, governments, and nonprofits the power to develop in-house expertise and satisfy employees’ hunger for learning and development.",
        link: "https://www.udemy.com/"
    },
    {
        id: 3,
        name: 'Coursera',
        type: 'Education',
        site_logo: "https://pbs.twimg.com/profile_images/579039906804023296/RWDlntRx_400x400.jpeg",
        link: "https://coursera.org/",

        description: "Every course on Coursera is taught by top instructors from world-class universities and companies, so you can learn something new anytime, anywhere. Hundreds of free courses give you access to on-demand video lectures, homework exercises, and community discussion forums. Paid courses provide additional quizzes and projects as well as a shareable Course Certificate upon completion."
    },
    {
        id: 4,
        name: 'Dev.to',
        type: 'Coding / News',
        site_logo: "https://res.cloudinary.com/practicaldev/image/fetch/c_scale,fl_progressive,q_auto,w_190/f_auto/https://practicaldev-herokuapp-com.freetls.fastly.net/assets/rainbowdev.svg",
        link: "https://Dev.to/",
        description:"DEV is a community of software developers getting together to help one another out. The software industry relies on collaboration and networked learning. We provide a place for that to happen."
    },
    {
        id: 5,
        name: 'Goodreads',
        type: 'Literature',
        site_logo: "https://alexabloom.com/wp-content/uploads/2017/04/Goodreads-icon.png",
        link: "https://goodreads.com/",
        description: "Goodreads is the world’s largest site for readers and book recommendations. Our mission is to help people find and share books they love. Goodreads launched in January 2007."
    },
    {
        id: 6,
        name: 'Duolingo',
        type: 'Language',
        site_logo: "https://pbs.twimg.com/profile_images/1145676431810322438/WM5QiRx1_400x400.png",
        link: "https://Duolingo.com/",
        description:"Duolingo is an American platform that includes a language-learning website and mobile app, as well as a digital language-proficiency assessment exam. The company uses the freemium model; the app and the website are accessible without charge, although Duolingo also offers a premium service for a fee"
    },
    {
        id: 7,
        name: 'Youtube',
        type: 'Education',
        site_logo: "https://assets.entrepreneur.com/content/3x2/2000/20180117155526-youtube.jpeg",
        link: "https://youtube.com/",
        description:"Youtube is a well-known tool that can be used for learning and is your best friend for free in-depth information"
    },
    {
        id: 8,
        name: 'LinkedIn',
        type: 'Networking',
        site_logo: "https://lh3.googleusercontent.com/fqYJHtyzZzA4vacRzeJoB93QNvA5-mvR-8UB5oVLxdYDSTpfLp_KgYD4IqVGJUgFEJo",
        link: "https://linkedin.com/",
        description:"LinkedIn is an American business and employment-oriented online service that operates via websites and mobile apps. Launched on May 5, 2003, it is mainly used for professional networking, including employers posting jobs and job seekers posting their CVs"
    },
    {
        id: 9,
        name: 'Audible',
        type: 'Literature',
        site_logo: "https://images-na.ssl-images-amazon.com/images/I/21MjMFj7JAL._QL70_ML2_.jpg",
        link: "https://audible.com/",
        description:"Audible is a seller and producer of spoken audio entertainment, information, and educational programming on the Internet. Audible sells digital audiobooks, radio and TV programs, and audio versions of magazines and newspapers"
    },
    {
        id: 10,
        name: 'Quizlet',
        type: 'Study',
        site_logo: "https://assets.quizlet.com/a/i/brandmark/1024.893fa7e00da6339.png",
        link: "https://quizlet.com/",
        description:"At Quizlet, we believe that anyone can learn anything. All it takes is a tenacious spirit, the right guidance, and the tools to see it through. We know that students are under more pressure than ever. It can leave them overwhelmed, be anxiety-producing and make it all too easy to burn out. It’s our job to give every student the tools and confidence to succeed, no matter what their motivation, or what they’re striving to achieve."
    },
    {
        id: 11,
        name: 'Github',
        type: 'Coding',
        site_logo: "https://avatars0.githubusercontent.com/u/9919?s=280&v=4",
        link: "https://github.com/",
        description:"We’re supporting a community where more than 50 million* people learn, share, and work together to build software."
    },
    {
        id: 12,
        name: 'React.js',
        type: 'Coding',
        site_logo: "https://reactjs.org/logo-og.png",
        link: "https://reactjs.org/",
        description:"React is a JavaScript library for building user interfaces. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications"
    },

    {
        id: 13,
        name: 'edX',
        type: 'Education',
        site_logo: "https://cdn-blog.lawrencemcdaniel.com/wp-content/uploads/2018/02/22125436/open-edx-banner.jpg",
        link: "https://edx.org/",
        description:"edX is the trusted platform for education and learning. Founded by Harvard and MIT, edX is home to more than 20 million learners, the majority of top-ranked universities in the world and industry-leading companies. As a global nonprofit, edX is transforming traditional education, removing the barriers of cost, location and access. Fulfilling the demand for people to learn on their own terms, edX is reimagining the possibilities of education, providing the highest-quality, stackable learning experiences including the groundbreaking MicroMasters® programs. Supporting learners at every stage, whether entering the job market, changing fields, seeking a promotion or exploring new interests, edX delivers courses for curious minds on topics ranging from data and computer science to leadership and communications. edX is where you go to learn."
    },

    {
        id: 14,
        name: 'Canva',
        type: 'Art',
        site_logo: "https://pbs.twimg.com/profile_images/1034958794277576704/EveRZNUE.jpg",
        link: "https://canva.com/",
        description:"Canva is a graphic design platform that allows users to create social media graphics, presentations, posters and other visual content. It is available on web and mobile, and integrates millions of images, fonts, templates and illustrations."
    }
]